class ContentsList extends HTMLElement {
  constructor() {
    super();

    this.articleContentHeadings = document.querySelectorAll(
      "[id^='template-article'] .article-main-content-wrapper .article-content-wrapper h1:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper h2:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper h3:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper h4:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper h5:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper .h1:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper .h2:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper .h3:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper .h4:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper .h5:not(.card__heading)"
    );

    this.addIDToHeadings(this.articleContentHeadings);
    this.populateContentsList(this.articleContentHeadings);
  }

  addIDToHeadings(headings) {
    if (headings) {
      headings.forEach((heading) => {
        heading.id = `article-${heading.textContent
          .toLowerCase()
          .replace(/\s+/g, "-")
          .replace("<p>", "")
          .replace("</p>", "")}`;
      });
    }
  }

  populateContentsList(headings) {
    if (headings.length > 0) {
      document
        .querySelector(".contents-list-wrapper")
        .classList.remove("hidden");
      const ul = document.createElement("ol");
      headings.forEach((heading) => {
        const li = document.createElement("li");
        const a = document.createElement("a");
        a.textContent = heading.innerText;
        a.href = `#article-${heading.textContent
          .toLowerCase()
          .replace(/\s+/g, "-")
          .replace("<p>", "")
          .replace("</p>", "")}`;
        li.appendChild(a);
        ul.appendChild(li);
      });
      this.appendChild(ul);
    } else {
      document.querySelector(".contents-list-wrapper").classList.add("hidden");
    }
  }
}
customElements.define("contents-list", ContentsList);
